import React from "react";
import "./RepresentativeDetailsForm.scss"; // We'll create this CSS file

export const RepresentativeDetailsForm: React.FC = () => {
  return (
    <div className="rep-details-form-container">
      {/* Adresse du représentant en RDC */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>
            Adresse du représentant en RDC (DRC Representative's address)
          </label>
        </div>
      </div>
      <div className="form-row input-line-row">
        <div className="input-cell full-width-input"></div>
      </div>

      {/* Nombre de véhicule */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>Nombre de véhicule (Number of trucks)</label>
        </div>
      </div>
      <div className="form-row input-line-row">
        <div className="input-cell full-width-input"></div>
      </div>

      {/* Numéros de chassis et d'immatriculation */}
      <div className="form-row header-label-row">
        <div className="label-cell single-line-label">
          <label>
            Numéros de chassis et d'immatriculation (Chassis number and
            Registration plate)
          </label>
        </div>
      </div>
      <div className="form-row input-line-row attachment-row">
        <div className="input-cell full-width-input attachment-text-cell">
          <p>VOIR DOCUMENT EN ANNEXE / ATTACHED FILES</p>
        </div>
      </div>

      {/* Poids minimum/maximum du chassis */}
      <div className="form-row two-column-row header-label-row">
        <div className="label-cell two-col-item">
          <label>Poids minimum du chassis (Min chassis weight)</label>
        </div>
        <div className="label-cell two-col-item">
          <label>Poids maximum du chassis (max chassis weight)</label>
        </div>
      </div>
      <div className="form-row two-column-row input-line-row">
        <div className="input-cell two-col-item"></div>
        <div className="input-cell two-col-item"></div>
      </div>
    </div>
  );
};
